import { jwtDecode } from "jwt-decode";

export const DEFAULT_NAMESPACE = "translation";
export const STUDENT_NAMESPACE = "student";

let cachedToken: string | null = null;
let cachedIsOperator = false;

function isOperator(): boolean {
  const token = localStorage.getItem("token");
  if (token === cachedToken) return cachedIsOperator;
  cachedToken = token;
  try {
    cachedIsOperator = !!token && jwtDecode<{ role?: string }>(token).role === "operator";
  } catch {
    cachedIsOperator = false;
  }
  return cachedIsOperator;
}

interface PostProcessTranslator {
  language?: string;
  exists: (key: string, options: object) => boolean;
  translate: (key: string, options: object) => string;
}

export const studentTerms = {
  type: "postProcessor" as const,
  name: "studentTerms",
  process(
    value: string,
    key: string | string[],
    options: object,
    translator: PostProcessTranslator,
  ) {
    if (!isOperator()) return value;

    const lookupKey = Array.isArray(key) ? key[0] : key;
    const lng = translator?.language;
    const inThisLanguageOnly = { ns: STUDENT_NAMESPACE, lng, fallbackLng: [] };

    if (!translator?.exists(lookupKey, inThisLanguageOnly)) return value;

    return translator.translate(lookupKey, {
      ...options,
      ...inThisLanguageOnly,
      postProcess: [],
    });
  },
};
